import React from 'react';

const AboutPage = () => {
    return (
        <div className="about-page">
            {/* About Hero */}
            <section className="about-hero">
                <div className="container">
                    <h1>About Megh.ai</h1>
                    <p>Passionate entrepreneurs transforming businesses through AI</p>
                </div>
            </section>

            {/* Who We Are */}
            <section className="about-content">
                <div className="container">
                    <div className="about-grid">
                        <div>
                            <h2>Who We Are</h2>
                            <p>
                                At Megh.ai, we are a team of talented entrepreneurs who are passionate
                                about helping businesses unleash the full potential of Artificial Intelligence.
                                Our expertise in enterprise applications allows us to identify the most suitable
                                AI solutions for your business needs, making your operations more seamless,
                                efficient, and cost-effective.
                            </p>
                            <p>
                                We work closely with our clients to understand their requirements, designing
                                solutions that optimize their operations end-to-end. Let us help you explore
                                the possibilities AI can bring to your enterprise.
                            </p>
                        </div>
                        <div className="about-image-container">
                            <img
                                src="https://static.wixstatic.com/media/11062b_23038e254b914d11b792ca46e48b637f~mv2_d_5000_3333_s_4_2.jpg/v1/fill/w_500,h_333,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/11062b_23038e254b914d11b792ca46e48b637f~mv2_d_5000_3333_s_4_2.jpg"
                                alt="Young Businesswomen - Team Collaboration"
                                className="about-image"
                            />
                        </div>
                    </div>
                </div>
            </section>

            {/* Technology Stack */}
            <section className="technology">
                <div className="container">
                    <div className="section-header">
                        <h2 className="section-title" style={{color: 'white'}}>Our Technology Stack</h2>
                        <p className="section-subtitle" style={{color: 'rgba(255, 255, 255, 0.8)'}}>
                            Comprehensive solutions across AI, automation, and integration
                        </p>
                    </div>
                    <div className="services-grid">
                        <div className="service-card tech-card">
                            <h3>Artificial Intelligence</h3>
                            <p>
                                Advanced machine learning algorithms and neural networks for intelligent
                                decision-making and predictive analytics.
                            </p>
                        </div>
                        <div className="service-card tech-card">
                            <h3>Robotic Process Automation</h3>
                            <p>
                                Streamline repetitive tasks and workflows with intelligent automation
                                solutions that reduce costs and improve accuracy.
                            </p>
                        </div>
                        <div className="service-card tech-card">
                            <h3>IoT Integration</h3>
                            <p>
                                Connect and monitor physical processes with smart IoT solutions for
                                real-time insights and adaptive decision-making.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* CEO Quote */}
            <section className="quote-section">
                <div className="container">
                    <div className="quote-container">
                        <p className="quote-text">
                            "Success comes to those who are passionate, persistent, and willing to work hard for it."
                        </p>
                        <div className="quote-author">
                            <div className="author-avatar">SK</div>
                            <div className="author-info">
                                <h4>Siva Kumar</h4>
                                <p>Chief Executive Officer</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Industry Insights with Real Video */}
            <section className="services" style={{background: '#f8fafc'}}>
                <div className="container">
                    <div className="section-header">
                        <h2 className="section-title">Industry Insights</h2>
                        <p className="section-subtitle">
                            Stay ahead with our latest research and industry perspectives
                        </p>
                    </div>
                    <div className="about-grid">
                        <div className="video-container">
                            <div className="video-thumbnail">
                                <img
                                    src="https://i.ytimg.com/vi/36UdaKNzpuw/maxresdefault.jpg"
                                    alt="Merger of OT and IT Video Thumbnail"
                                    className="video-thumbnail-img"
                                />
                                <div className="video-overlay">
                                    <div className="play-button">
                                        <svg width="50" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="12" cy="12" r="12" fill="rgba(255,255,255,0.9)"/>
                                            <polygon points="10,8 16,12 10,16" fill="#ff6b35"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <p className="video-title">📹 Video: "Merger of OT and IT"</p>
                        </div>
                        <div>
                            <h3>Featured Content</h3>
                            <p>
                                You've probably heard of industry 4.0, smart manufacturing, Human Machine
                                Interface, and the industrial Internet of Things. These are all ways of
                                describing the intersection of operational technology and information
                                technology to monitor physical processes within manufacturing.
                            </p>
                            <div style={{marginTop: '1.5rem'}}>
                                <a
                                    href="https://www.youtube.com/watch?v=36UdaKNzpuw"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="cta-button"
                                    style={{marginRight: '1rem'}}
                                >
                                    Watch Video
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AboutPage;